import Vue from "vue";
import Router from "vue-router";
import Dashboard from "../paginas/Dashboard.vue";
import store from "./store";
import { baseApiUrl, isUserTemPerssaoGlobal } from "@/config/global";

Vue.use(Router);

const router = new Router({
  mode: "history",
  routes: [
    {
      path: "/" + process.env.VUE_APP_BASE_URL,
      name: "dashboard",
      component: Dashboard,
    },
    {
      path: "/" + process.env.VUE_APP_BASE_URL + "/ferias/chefia",
      component: () => import("@/paginas/ferias/ChefiaAprovacao.vue"),
      children: [
        {
          path: "",
          name: "feriasChefiaPendenteValidacao",
          component: () =>
            import("@/paginas/ferias/ChefiaPendenteAprovacao.vue"),
        },
        {
          path: "/" + process.env.VUE_APP_BASE_URL + "/ferias/chefia/validos",
          name: "feriasChefiaValidos",
          component: () => import("@/paginas/ferias/ChefiaValidos.vue"),
        },
        {
          path:
            "/" + process.env.VUE_APP_BASE_URL + "/ferias/chefia/naoAgendado",
          name: "feriasChefiaNaoAgendado",
          component: () => import("@/paginas/ferias/ChefiaNaoAgendado.vue"),
        },
        {
          path: "/" + process.env.VUE_APP_BASE_URL + "/ferias/chefia/agenda",
          name: "feriasChefiaNaoAgendadoagenda",
          component: () => import("@/paginas/ferias/ChefiaAgenda.vue"),
        },
      ],
    },
    {
      path: "/" + process.env.VUE_APP_BASE_URL + "/ferias/servidor",
      name: "feriasServidor",
      component: () => import("@/paginas/ferias/feriasServidor.vue"),
    },
    {
      path: "/" + process.env.VUE_APP_BASE_URL + "/holerite",
      name: "holerite",
      component: () => import("@/paginas/holerite/Holerite.vue"),
    },
    {
      path: "/" + process.env.VUE_APP_BASE_URL + "/fichafinanceira",
      name: "fichafinanceira",
      component: () => import("@/paginas/fichafinanceira/FichaFinanceira.vue"),
    },
    {
      path: "/" + process.env.VUE_APP_BASE_URL + "/licencapremio/servidor",
      name: "licencaPremioServidor",
      component: () =>
        import("@/paginas/licencapremio/licencaPremioServidor.vue"),
    },
    {
      path: "/" + process.env.VUE_APP_BASE_URL + "/servidor/dadosPessoais",
      name: "dadosPessoaisServidor",
      component: () => import("@/paginas/servidor/dadosPessoais.vue"),
    },
    {
      path: "/" + process.env.VUE_APP_BASE_URL + "/seguranca/cadastro/usuario",
      name: "cadastroUsuario",
      component: () => import("@/paginas/seguranca/CadastroUsuario.vue"),
    },
    {
      path: "/" + process.env.VUE_APP_BASE_URL + "/cadastro/usuario/novo",
      name: "usuarioContainer",
      component: () => import("@/paginas/seguranca/ContainerUsuario.vue"),
    },
    {
      path: "/" + process.env.VUE_APP_BASE_URL + "/cadastro/usuario/dados",
      name: "usuarioDados",
      component: () => import("@/paginas/seguranca/TabPanelDados.vue"),
    },
    {
      path:
        "/" + process.env.VUE_APP_BASE_URL + "/cadastro/usuario/novo/vinculos",
      name: "usuarioVinculos",
      component: () => import("@/paginas/seguranca/TabPanelVinculos.vue"),
    },
    {
      path: "/" + process.env.VUE_APP_BASE_URL + "/cadastro/usuario/perfil",
      name: "usuarioPerfil",
      component: () => import("@/paginas/seguranca/TabPanelPerfilAcesso.vue"),
    },
    {
      path: "/" + process.env.VUE_APP_BASE_URL + "/retratoFuncional",
      name: "retratoFuncional",
      component: () => import("@/paginas/servidor/retratoFuncional.vue"),
    },
    {
      path: "/" + process.env.VUE_APP_BASE_URL + "/contribuicaoPrevidenciaria",
      name: "contribuicaoPrevidenciaria",
      component: () =>
        import("@/paginas/servidor/contribuicaoPrevidenciaria.vue"),
    },
    {
      path: "/" + process.env.VUE_APP_BASE_URL + "/cedulac",
      name: "cedulac",
      component: () => import("@/paginas/servidor/cedulac.vue"),
    },
    {
      path: "/" + process.env.VUE_APP_BASE_URL + "/controlePerfilChefia",
      name: "controlePerfilChefia",
      component: () =>
        import("@/paginas/controlePerfilChefia/controlePerfilChefia.vue"),
    },
    // {
    // 	path: '/' + process.env.VUE_APP_BASE_URL + '/avaliacao',
    // 	name: 'avaliacao',
    // 	component: () => import('@/paginas/avaliacao/avaliacao.vue'),
    // 	children: [
    // 		{
    // 			path: `/${process.env.VUE_APP_BASE_URL}/avaliacao/avaliarQuestionario/:name`,
    // 			name: "avaliacao-avaliarQuestionario",
    // 			component: () => import('@/paginas/avaliacao/avaliarQuestionario.vue')
    // 		},
    // 		{
    // 			path: `/${process.env.VUE_APP_BASE_URL}/avaliacao/confirmarQuestionario`,
    // 			name: "avaliacao-avaliarQuestionarioConfirmar",
    // 			component: () => import('@/paginas/avaliacao/confirmarQuestionario.vue')
    // 		}
    // 	]
    // },

    {
      path: "/" + process.env.VUE_APP_BASE_URL + "/liberacaoFerias",
      name: "liberacaoFerias",
      component: () => import("@/paginas/liberacaoFerias/LiberacaoFerias.vue"),
    },
    {
      path: "/" + process.env.VUE_APP_BASE_URL + "/relatorio",
      name: "gerenciaRelatorios",
      component: () => import("@/paginas/relatorios/relatorios.vue"),
    },
    {
      path: "/" + process.env.VUE_APP_BASE_URL + "/cadEscala",
      name: "cadEscala",
      component: () => import("@/paginas/rh/cadEscala.vue"),
    },
    {
      path: "/" + process.env.VUE_APP_BASE_URL + "/gestaoferias",
      name: "gestaoferias",
      component: () => import("@/paginas/rh/gestaoFerias.vue"),
    },
    {
      path: "/" + process.env.VUE_APP_BASE_URL + "/escalaAnualRh/ferias",
      name: "escalaAnualRhFerias",
      component: () => import("@/paginas/rh/escalaAnualFeriasRh.vue"),
    },
    {
      path: "/" + process.env.VUE_APP_BASE_URL + "/escalaAnualRh/licencapremio",
      name: "escalaAnualRhLicencaPremio",
      component: () => import("@/paginas/rh/escalaAnualLicencaPremioRh.vue"),
    },
    {
      path: "/" + process.env.VUE_APP_BASE_URL + "/vinculo",
      name: "vinculo",
      component: () => import("@/paginas/vinculo/Vinculo.vue"),
    },
    {
      path: "/" + process.env.VUE_APP_BASE_URL + "/certidoes",
      name: "certidoes",
      component: () => import("@/paginas/certidoes/Certidoes.vue"),
    },
    {
      path: "/" + process.env.VUE_APP_BASE_URL + "/idicecalculojurus",
      name: "indiceCalculo",
      component: () =>
        import("@/paginas/verbaIdenizatoria/indicesCalculo.vue"),
    },
    {
      path: "/" + process.env.VUE_APP_BASE_URL + "/idenizacao/umTercoFerias",
      name: "solicitaVerba",
      component: () =>
        import("@/paginas/verbaIdenizatoria/solicitacaoIdenizatoria.vue"),
    },
    {
      path:
        "/" +
        process.env.VUE_APP_BASE_URL +
        "/idenizacao/umTercoFerias/solicitacao",
      name: "solicitaVerbaForm",
      component: () =>
        import("@/paginas/verbaIdenizatoria/solicitacaoIdenizatoriaForm.vue"),
    },
    {
      path:
        "/" +
        process.env.VUE_APP_BASE_URL +
        "/idenizacao/umTercoFerias/valida/despacho",
      name: "solicitaVerbaValidaDespacho",
      component: () =>
        import(
          "@/paginas/verbaIdenizatoria/solicitacaoIdenizatoriaValidaDespacho.vue"
        ),
    },
    {
      path:
        "/" +
        process.env.VUE_APP_BASE_URL +
        "/idenizacao/umTercoFerias/validador",
      name: "solicitaVerbaProcurador",
      component: () =>
        import(
          "@/paginas/verbaIdenizatoria/solicitacaoIdenizatoriaProcurador.vue"
        ),
    },
    {
      path:
        "/" +
        process.env.VUE_APP_BASE_URL +
        "/idenizacao/umTercoFerias/despacho",
      name: "solicitaVerbaDespacho",
      component: () =>
        import(
          "@/paginas/verbaIdenizatoria/solicitacaoIdenizatoriaDespacho.vue"
        ),
    },
    {
      path:
        "/" +
        process.env.VUE_APP_BASE_URL +
        "/idenizacao/umTercoFerias/despacho/view",
      name: "solicitaVerbaDespachoView",
      component: () =>
        import(
          "@/paginas/verbaIdenizatoria/solicitacaoIdenizatoriaDespachoVisualizar.vue"
        ),
    },
    {
      path:
        "/" +
        process.env.VUE_APP_BASE_URL +
        "/idenizacao/parametro",
      name: "parametroSolicitacao",
      component: () =>
        import(
          "@/paginas/verbaIdenizatoria/parametrosSolicitacao.vue"
        ),
    },
    {
      path: "/" + process.env.VUE_APP_BASE_URL + "/orgaoVinculado",
      name: "orgaoVinculado",
      component: () => import("@/paginas/orgaoVinculado/orgaoVinculado.vue"),
    },
    {
      path:
        "/" +
        process.env.VUE_APP_BASE_URL +
        "/datalimitesocilicitacaoafastamento",
      name: "datalimitesocilicitacaoafastamento",
      component: () =>
        import(
          "@/paginas/datalimitesocilicitacaoafastamento/datalimitesocilicitacaoafastamento.vue"
        ),
    },
    {
      path: "/" + process.env.VUE_APP_BASE_URL + "/publico/tabela-salarial",
      name: "tabelaSalarial-publico",
      component: () => import("@/paginas/publico/tabelaSalarial.vue"),
    },
    {
      path: "/" + process.env.VUE_APP_BASE_URL + "/publico/cedulac",
      name: "cedulac-publico",
      component: () => import("@/paginas/publico/cedulac.vue"),
    },
    // {
    //   path: "/" + process.env.VUE_APP_BASE_URL + "/publico/cedulac-temp",
    //   name: "cedulac-publico-temp",
    //   component: () => import("@/paginas/publico/cedulac-temp.vue"),
    // },
    {
      path: "/" + process.env.VUE_APP_BASE_URL + "/publico/certidoes",
      name: "certidoes-publico",
      component: () => import("@/paginas/publico/certidoes.vue"),
    },
    {
      path:
        "/" +
        process.env.VUE_APP_BASE_URL +
        "/publico/validaFichaFinanceira/:hash",
      name: "validaFichaFinanceira-publico",
      component: () => import("@/paginas/publico/validaFichaFinanceira.vue"),
    },
    {
      path:
        "/" +
        process.env.VUE_APP_BASE_URL +
        "/publico/validaCarteiraFuncionalDigital/:hash",
      name: "validaCarteiraFuncionalDigital-publico",
      component: () =>
        import("@/paginas/publico/validaCarteiraFuncionalDigital.vue"),
    },
    {
      path: "/" + process.env.VUE_APP_BASE_URL + "/publico/validaHolerite",
      name: "validaHolerite-publico",
      component: () => import("@/paginas/publico/validaHolerite.vue"),
    },
    {
      path: "/" + process.env.VUE_APP_BASE_URL + "/publico/certidoes/:chave",
      name: "certidoes-publico-relatorio",
      component: () => import("@/paginas/publico/ValidaCertidao.vue"),
    },
    {
      path:
        "/" + process.env.VUE_APP_BASE_URL + "/publico/validaHolerite/:chave",
      name: "certidoes-publico-relatorio-qrcode",
      component: () => import("@/paginas/publico/ValidaHoleriteQRCode.vue"),
    },
    {
      path: "/" + process.env.VUE_APP_BASE_URL + "/dre/manter-dre",
      name: "manterDRE",
      component: () => import("@/paginas/dre/ManterDRE.vue"),
    },
    {
      path: "/" + process.env.VUE_APP_BASE_URL + "/dre/vincular-escolas",
      name: "vincularEscolas",
      component: () => import("@/paginas/dre/VincularEscolas.vue"),
    },
    {
      path: "/" + process.env.VUE_APP_BASE_URL + "/cronogramaFerias",
      name: "cronogramaFerias",
      component: () => import("@/paginas/ferias/CronogramaDeFerias.vue"),
    },
    /* {
			path: '/cadastroempregado',
			name: 'cadastroempregadorpublico-publico',
			component: CadFormEmpregadorPublico
		} */
    //URL PARA O MT PREVE
    {
      path: "/mtPreve",
      name: "mtPrev",
      component: () => import("@/paginas/servidor/mtPreve.vue"),
      beforeEnter() {
        let dadosMTPrev = {
          Matricula: store.getters.getMatricula,
          Cpf: store.getters.getUser.contaAcesso.pessoa.numrCpf,
        };
        Vue.prototype.$http
          .post(`${baseApiUrl}/mtprev/linkacesso`, JSON.stringify(dadosMTPrev))
          .then((res) => {
            window.location.href = res.data;
          });
      },
    },
    {
      path: "/sga",
      name: "sga",
      component: () => import("@/paginas/servidor/sga.vue"),
      beforeEnter() {
        //console.log(process.env.VUE_APP_API_URL_SGA);
        window.open(process.env.VUE_APP_API_URL_SGA, "_blank");
      },
    },
  ],
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
});
router.beforeEach((to, from, next) => {
  let liberatudo = false;  
  let publico = false;
  let name = window.location.href.split("/")
  if(name.length > 4 && name[4] == "publico"){
    publico = true
  }
  let LocalStorageSeplag = localStorage.getItem(
    process.env.VUE_APP_USER_KEY
  );
  let dadosStorageSeplagJson = null;
  if (LocalStorageSeplag) {
    dadosStorageSeplagJson = decodeURI(atob(LocalStorageSeplag));
  }
  let storageSeplagJson = JSON.parse(dadosStorageSeplagJson);
  let getUser = null
  if(storageSeplagJson){
    if (
      storageSeplagJson[process.env.VUE_APP_NOME_SISTEMA] &&
      storageSeplagJson[process.env.VUE_APP_NOME_SISTEMA].seguranca
    ) {
      getUser = storageSeplagJson[process.env.VUE_APP_NOME_SISTEMA].seguranca;
    }
  }

  if (
    to.name == "dashboard" ||
    liberatudo ||
    (to.name &&
      to.name.split("-").length > 0 &&
      to.name.split("-")[1] == "publico")
  ) {
    next();
  } else if(getUser) {
    let nomePermissao = to.name;
    if (to.name && to.name.split("-").length > 0) {
      nomePermissao = to.name.split("-")[0];
    }
    if (isUserTemPerssaoGlobal(nomePermissao)|| publico == true) {
      next();
    } else {
      setTimeout(() => {
        Vue.prototype.$toast.add({
          severity: "error",
          summary: "Você não possui permissão para acessar essa página.",
          life: 10000,
        });
      }, 0);
      next({ name: "dashboard" });
    }
  } else {
    Vue.prototype.$toast.add({
      severity: "error",
      summary: "Você NÃO possui Permissão para acessar essa Página!!!",
      life: 6000,
    });
    next({ name: "dashboard" });
  }
});
export default router;
